import { motion } from "framer-motion";

const STAGES = [
  { minLevel: 1, label: "Baby Scholar", sublabel: "Just starting out", color: "#FFD836" },
  { minLevel: 3, label: "Little Reader", sublabel: "Building habits", color: "#7DD3FC" },
  { minLevel: 5, label: "Bookworm", sublabel: "Deep in the stacks", color: "#86EFAC" },
  { minLevel: 7, label: "Academic", sublabel: "Serious knowledge", color: "#C4B5FD" },
  { minLevel: 9, label: "Distinguished Scholar", sublabel: "Mastery achieved", color: "#FFD836" },
];

function getStageIndex(level) {
  for (let i = STAGES.length - 1; i >= 0; i--) {
    if (level >= STAGES[i].minLevel) return i;
  }
  return 0;
}

function BabySvg({ size }) {
  return (
    <svg width={size} height={size} viewBox="0 0 120 120" fill="none">
      <ellipse cx="60" cy="75" rx="28" ry="24" fill="#FFE4B5" />
      <circle cx="60" cy="42" r="28" fill="#FFE4B5" />
      <circle cx="45" cy="48" r="6" fill="#FFB6C1" opacity="0.5" />
      <circle cx="75" cy="48" r="6" fill="#FFB6C1" opacity="0.5" />
      <circle cx="50" cy="40" r="4" fill="#1A1A1A" />
      <circle cx="70" cy="40" r="4" fill="#1A1A1A" />
      <circle cx="51.5" cy="38.5" r="1.5" fill="white" />
      <circle cx="71.5" cy="38.5" r="1.5" fill="white" />
      <path d="M55 52 Q60 58 65 52" stroke="#1A1A1A" strokeWidth="2" fill="none" strokeLinecap="round" />
      <rect x="42" y="72" width="16" height="12" rx="2" fill="#7DD3FC" stroke="#1A1A1A" strokeWidth="1.5" />
      <line x1="50" y1="72" x2="50" y2="84" stroke="#1A1A1A" strokeWidth="1" />
      <path d="M55 16 Q60 8 65 16" stroke="#8B6914" strokeWidth="3" fill="none" strokeLinecap="round" />
    </svg>
  );
}

function ChildSvg({ size }) {
  return (
    <svg width={size} height={size} viewBox="0 0 120 120" fill="none">
      <ellipse cx="60" cy="80" rx="24" ry="20" fill="#7DD3FC" />
      <circle cx="60" cy="42" r="26" fill="#FFE4B5" />
      <circle cx="50" cy="40" r="8" stroke="#1A1A1A" strokeWidth="2" fill="none" />
      <circle cx="70" cy="40" r="8" stroke="#1A1A1A" strokeWidth="2" fill="none" />
      <line x1="58" y1="40" x2="62" y2="40" stroke="#1A1A1A" strokeWidth="2" />
      <circle cx="50" cy="40" r="3" fill="#1A1A1A" /><circle cx="70" cy="40" r="3" fill="#1A1A1A" />
      <circle cx="51" cy="39" r="1" fill="white" /><circle cx="71" cy="39" r="1" fill="white" />
      <path d="M55 53 Q60 58 65 53" stroke="#1A1A1A" strokeWidth="2" fill="none" strokeLinecap="round" />
      <rect x="36" y="74" width="20" height="14" rx="2" fill="#FFD836" stroke="#1A1A1A" strokeWidth="1.5" />
      <path d="M35 32 Q40 18 60 16 Q80 18 85 32" stroke="#6B4226" strokeWidth="4" fill="#6B4226" />
      <path d="M42 65 L38 80" stroke="#FF6B6B" strokeWidth="3" strokeLinecap="round" />
      <path d="M78 65 L82 80" stroke="#FF6B6B" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}

function TeenSvg({ size }) {
  return (
    <svg width={size} height={size} viewBox="0 0 120 120" fill="none">
      <ellipse cx="60" cy="82" rx="22" ry="18" fill="#86EFAC" />
      <circle cx="60" cy="42" r="25" fill="#FFE4B5" />
      <rect x="40" y="34" width="16" height="12" rx="3" stroke="#1A1A1A" strokeWidth="2" fill="none" />
      <rect x="64" y="34" width="16" height="12" rx="3" stroke="#1A1A1A" strokeWidth="2" fill="none" />
      <line x1="56" y1="40" x2="64" y2="40" stroke="#1A1A1A" strokeWidth="2" />
      <circle cx="48" cy="40" r="2.5" fill="#1A1A1A" /><circle cx="72" cy="40" r="2.5" fill="#1A1A1A" />
      <path d="M55 52 Q60 56 65 52" stroke="#1A1A1A" strokeWidth="2" fill="none" strokeLinecap="round" />
      <rect x="70" y="72" width="18" height="5" rx="1" fill="#FF6B6B" stroke="#1A1A1A" strokeWidth="1" />
      <rect x="68" y="67" width="18" height="5" rx="1" fill="#7DD3FC" stroke="#1A1A1A" strokeWidth="1" />
      <rect x="72" y="62" width="18" height="5" rx="1" fill="#FFD836" stroke="#1A1A1A" strokeWidth="1" />
      <path d="M36 35 Q40 16 60 14 Q80 16 84 35" fill="#4A3728" />
    </svg>
  );
}

function StudentSvg({ size }) {
  return (
    <svg width={size} height={size} viewBox="0 0 120 120" fill="none">
      <ellipse cx="60" cy="82" rx="22" ry="18" fill="#C4B5FD" />
      <circle cx="60" cy="42" r="25" fill="#FFE4B5" />
      <ellipse cx="50" cy="40" rx="3" ry="3.5" fill="#1A1A1A" /><ellipse cx="70" cy="40" rx="3" ry="3.5" fill="#1A1A1A" />
      <circle cx="51" cy="38.5" r="1.2" fill="white" /><circle cx="71" cy="38.5" r="1.2" fill="white" />
      <path d="M52 52 Q60 59 68 52" stroke="#1A1A1A" strokeWidth="2.5" fill="none" strokeLinecap="round" />
      <rect x="38" y="18" width="44" height="6" rx="1" fill="#1A1A1A" />
      <polygon points="60,6 38,20 82,20" fill="#1A1A1A" />
      <line x1="60" y1="6" x2="82" y2="12" stroke="#FFD836" strokeWidth="2" /><circle cx="84" cy="13" r="3" fill="#FFD836" />
      <path d="M40 74 Q50 70 60 74 Q70 70 80 74 L80 90 Q70 86 60 90 Q50 86 40 90 Z" fill="white" stroke="#1A1A1A" strokeWidth="1.5" />
      <line x1="60" y1="74" x2="60" y2="90" stroke="#1A1A1A" strokeWidth="1" />
      <path d="M36 28 Q40 18 60 16 Q80 18 84 28" fill="#2C1810" />
    </svg>
  );
}

function ScholarSvg({ size }) {
  return (
    <svg width={size} height={size} viewBox="0 0 120 120" fill="none">
      <circle cx="60" cy="55" r="55" fill="url(#glow2)" opacity="0.3" />
      <defs><radialGradient id="glow2"><stop offset="0%" stopColor="#FFD836" /><stop offset="100%" stopColor="#FFD836" stopOpacity="0" /></radialGradient></defs>
      <path d="M36 68 L30 105 L90 105 L84 68" fill="#1A1A1A" />
      <path d="M36 68 L30 105" stroke="#FFD836" strokeWidth="2" /><path d="M84 68 L90 105" stroke="#FFD836" strokeWidth="2" />
      <circle cx="60" cy="42" r="24" fill="#FFE4B5" />
      <ellipse cx="50" cy="40" rx="3" ry="2" fill="#1A1A1A" /><ellipse cx="70" cy="40" rx="3" ry="2" fill="#1A1A1A" />
      <path d="M52 50 Q60 56 68 50" stroke="#1A1A1A" strokeWidth="2" fill="none" strokeLinecap="round" />
      <rect x="36" y="20" width="48" height="6" rx="1" fill="#1A1A1A" />
      <polygon points="60,6 34,22 86,22" fill="#1A1A1A" />
      <line x1="60" y1="6" x2="86" y2="14" stroke="#FFD836" strokeWidth="2.5" /><circle cx="88" cy="15" r="4" fill="#FFD836" />
      <circle cx="24" cy="20" r="2" fill="#FFD836" opacity="0.8" />
      <circle cx="96" cy="28" r="1.5" fill="#FFD836" opacity="0.6" />
      <circle cx="18" cy="50" r="1.5" fill="#FFD836" opacity="0.7" />
      <path d="M37 28 Q42 18 60 16 Q78 18 83 28" fill="#555" />
    </svg>
  );
}

const SVG_MAP = [BabySvg, ChildSvg, TeenSvg, StudentSvg, ScholarSvg];

export default function AvatarTimeline({ level = 1 }) {
  const currentIdx = getStageIndex(level);

  return (
    <div className="neo-card dark:bg-[#1E1E1E] dark:border-[#444] dark:shadow-[4px_4px_0px_0px_#444]" data-testid="avatar-timeline">
      <h2 className="font-heading font-extrabold text-xl mb-4 dark:text-white text-center">Your Scholar Journey</h2>
      <div className="flex items-end justify-between gap-2 overflow-x-auto pb-2">
        {STAGES.map((stage, i) => {
          const SvgComp = SVG_MAP[i];
          const isActive = i === currentIdx;
          const isLocked = i > currentIdx;
          const size = isActive ? 100 : 70;
          return (
            <div key={i} className="flex flex-col items-center flex-shrink-0" style={{ minWidth: isActive ? 120 : 85 }}>
              <motion.div
                animate={isActive ? { y: [0, -6, 0] } : {}}
                transition={isActive ? { duration: 2, repeat: Infinity, ease: "easeInOut" } : {}}
                className={`relative ${isLocked ? "opacity-30 grayscale" : ""}`}
              >
                <SvgComp size={size} />
                {isActive && (
                  <motion.div
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    className="absolute -bottom-1 -right-1 w-7 h-7 rounded-full border-2 border-neo-border dark:border-[#444] shadow-[2px_2px_0px_0px_#1A1A1A] flex items-center justify-center font-heading font-extrabold text-xs"
                    style={{ backgroundColor: stage.color }}
                  >
                    {level}
                  </motion.div>
                )}
              </motion.div>
              <p className={`font-heading font-bold text-xs mt-1 text-center ${isActive ? "dark:text-white" : "text-neo-text-secondary dark:text-gray-500"}`}>
                {stage.label}
              </p>
              {isActive && (
                <p className="text-[10px] text-neo-text-secondary dark:text-gray-400 text-center">{stage.sublabel}</p>
              )}
              {isLocked && (
                <p className="text-[10px] text-neo-text-secondary dark:text-gray-500">Lv {stage.minLevel}</p>
              )}
            </div>
          );
        })}
      </div>
      {/* Progress to next */}
      {currentIdx < STAGES.length - 1 && (
        <div className="mt-3 pt-3 border-t-2 border-neo-border/20 dark:border-[#444]/40">
          <div className="flex justify-between text-xs text-neo-text-secondary dark:text-gray-400 mb-1">
            <span>{STAGES[currentIdx].label}</span>
            <span>{STAGES[currentIdx + 1].label}</span>
          </div>
          <div className="h-2 rounded-full bg-gray-200 dark:bg-gray-700 overflow-hidden">
            <motion.div
              className="h-full rounded-full"
              style={{ backgroundColor: STAGES[currentIdx].color }}
              initial={{ width: 0 }}
              animate={{ width: `${((level - STAGES[currentIdx].minLevel) / (STAGES[currentIdx + 1].minLevel - STAGES[currentIdx].minLevel)) * 100}%` }}
              transition={{ duration: 1, ease: "easeOut" }}
            />
          </div>
          <p className="text-[10px] text-center text-neo-text-secondary dark:text-gray-500 mt-1">
            Level {STAGES[currentIdx + 1].minLevel} to evolve
          </p>
        </div>
      )}
    </div>
  );
}
